import { render } from "./LocalAuth.vue?vue&type=template&id=1f2dd352&ts=true"
import script from "./LocalAuth.vue?vue&type=script&lang=ts"
export * from "./LocalAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__